

import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Select, Dialo, Tabs } from 'antd';
import FormRender, { useForm } from 'form-render';
import { Dialog,  } from 'antd-mobile';
import { FormConfigProvider, FormConfigContext } from './provider';
import can from '../../../../components/ability';


export default (props) => {
    
    const { value, onChange, addons } = props;
    const [list, setList] = useState([]);
    const globalConfig = useContext(FormConfigContext);
    const { accId, shopId } = globalConfig;

    const getList = async () => {
        if (!shopId) return;
        
        const response = await fetch('/api/userApp/shop/type-list' + '?shopId=' + shopId);
        const result = await response.json();

        if (result?.success) {
            return result.data.map(i => ({
                value: i.cateId,
                label: i.title
            }));
        }else {
            message.error(result.message);
            return []
        }
    }; 
    useEffect(() => {
        getList().then(res => setList(res));
        return;
    }, []);

    
    return (
        <div className='comp-form-customer-field'>
            <Select
                style={{width: '100%'}}
                onChange={onChange}
                value={value}
                allowClear
                options={list}
                placeholder="请选择类目"
            />
        </div>
    );
};